// hooks/useSocket.ts
import { useEffect, useState } from "react";
import { io, Socket } from "socket.io-client";

export const useSocket = (userId?: string) => {
  const [socket, setSocket] = useState<Socket | null>(null);

  useEffect(() => {
    const instance = io(process.env.REACT_APP_SOCKET_URL as string, {
      transports: ["websocket", "polling"],
      withCredentials: true,
    });

    setSocket(instance);

    instance.on("connect", () => {
      if (userId) {
        instance.emit("identify", { userId });
      }
    });

    instance.on("connect_error", (_err) => {
      // Intentionally no console noise in production builds
    });

    return () => {
      instance.disconnect();
      setSocket(null);
    };
  }, [userId]);

  return socket;
};
